<template>
  <nav class="breadcrumb-nav">
    <span
      v-for="(item, index) in pathArray"
      :key="index"
      class="bc-item"
    >
      {{ item.label }}
      <span v-if="index < pathArray.length - 1"> / </span>
    </span>
  </nav>
</template>

<script>
export default {
  name: "BreadcrumbNav",
  props: {
    pathArray: {
      type: Array,
      required: true
    }
  }
};
</script>

<style scoped>
.breadcrumb-nav {
  padding: 10px 20px;
  font-size: 14px;
  margin-top: 50px;
  color: #444;
}

.bc-item {
  font-weight: 600;
  cursor: default;   /* 👈 ya no parece link */
}

</style>
